import { useContext } from "react";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import Select, { components } from "react-select";
import AppContext from "../../context/AppContext";

const CheckboxOption = (props) => {
    const { langMode } = useContext(AppContext);
    const isArabic = langMode === 'ar';

    return (
        <div>
            <components.Option
                {...props}
                className={`!flex justify-between items-center !text-[#00000066] border-b border-b-1 border-b-[#00000066] !py-3 !px-[10px] ${isArabic ? 'text-[14px]' : 'text-[16px]'}`}
            >
                <label className={`${isArabic ? 'text-[14px]' : 'text-[16px]'}`}>{props.label}</label>
                {props?.isMulti && (
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        className={`${isArabic ? 'text-[14px]' : 'text-[16px]'}`}
                        onChange={() => null}
                        style={{
                            cursor: "pointer",
                            borderRadius: "4px",
                            width: "16px",
                            height: "16px",
                        }}
                    />
                )}
            </components.Option>
        </div>
    );
};


const DropdownIndicator = (
    props
) => {
    const { menuIsOpen } = props.selectProps;
    return (
        <components.DropdownIndicator {...props} >
            {menuIsOpen ? <FaAngleUp size={20} className="text-[#00000066]" /> : <FaAngleDown size={20} className="text-[#00000066]"  />}
        </components.DropdownIndicator>
    );
};


const ReactSelector = ({ options, onChange, defaultValue, height = "46px" , isDisabled, components={}, placeholder,isClearable, borderRadius,background,defaultMenuIsOpen,optionbackground, isMulti,fontSize="16px", overflow,isSearchable,borderColor="#00000066", ...rest}) => {

    const {
        langMode,
    } = useContext(AppContext); 
    return (
        <Select
            {...rest}
            isMulti={isMulti}
            defaultMenuIsOpen={defaultMenuIsOpen}
            isClearable={isClearable}
            className="basic-single"
            classNamePrefix="select"
            options={options}
            isDisabled={isDisabled}
            defaultValue={defaultValue}
            components={{ Option: CheckboxOption, DropdownIndicator, IndicatorSeparator: () => null , components}}
            placeholder={placeholder}
            onChange={onChange}
            isSearchable={isSearchable}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: height,
                    borderColor: state.isFocused || state.selectProps.menuIsOpen ? 'transparent' : borderColor,
                    boxShadow: state.isFocused || state.selectProps.menuIsOpen ? '0 0 0 1px #D1D5DB' : '0 0 0 1px #D1D5DB',
                    borderRadius: borderRadius || "8px",
                    background: background,
                    ...(overflow && { overflowX: overflow })
                }),
                menu: (baseStyles) => ({
                    ...baseStyles,
                    width: "100% !important",
                    minWidth: "100%",
                    zIndex: "1111",
                    marginTop: "1px",
                    borderTop: 0,
                }),
                menuList: (baseStyles) => ({
                    ...baseStyles,
                    width: "100%",
                    zIndex: "111",
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    whiteSpace: "nowrap"
                }),
                option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? 'transparent' : optionbackground || 'white',
                }),
                placeholder: (provided) => ({
                    ...provided,
                    fontSize: fontSize
                }),
                singleValue: (provided) => ({
                    ...provided,
                    fontSize: fontSize, // ✅ Use the same fontSize passed in props
                    marginBottom:`${langMode === "ar" ? "10px": '0'}`,
                    color: "#00000066" // Optional: match color with the options
                }),
            }}
            
        />
    )
}

export default ReactSelector;